// extracted by mini-css-extract-plugin
module.exports = {"resultItem2":"ValueCard2_resultItem2__2HyxO","resultItemTitle":"ValueCard2_resultItemTitle__1I3OY","amountNumber":"ValueCard2_amountNumber__1xcvk"};